<template>
    <v-row>
        <v-col>
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-btn @click="$refs.calendar.prev()" class="mr-4">
                                <v-icon left>fa-arrow-left</v-icon>
                                Sidste måned
                            </v-btn>
                        </v-col>
                        <v-col>
                            <loader v-if="loading" />
                        </v-col>
                        <v-col class="text-end">
                            <v-btn @click="$refs.calendar.next()">
                                Næste måned
                                <v-icon right>fa-arrow-right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-sheet height="800">
                                <v-calendar
                                    ref="calendar"
                                    v-model="value"
                                    locale="da"
                                    :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                                    :events="meetings"
                                    :event-color="getEventColor"
                                    @change="getData"
                                    @click:event="clickEvent"
                                >
                                </v-calendar>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import moment from 'moment'

export default {
    data () {
        return {
            value: '',
            meetings: [],
            loading: false,
            calendarState: {}
        }
    },
    computed: {
        filters () {
            return this.$store.state.meetings.filters
        },
        range () {
            return this.$store.state.meetings.range
        },
        team () {
            return this.$store.state.meetings.team
        },
        salesAgent () {
            return this.$store.state.meetings.salesAgent
        }
    },
    methods: {
        clickEvent (event) {
            const type = event.eventParsed.input.type
            const date = event.day.date
            this.$store.state.meetings.period = 'Selvvalgt'
            this.$store.state.meetings.range = [ date, date ]
            if (type === 'meetingsCount') {
                this.$store.state.meetings.filters.status = null
                this.$store.state.meetings.filters.result = null
                this.$store.state.meetings.filters.offerStatus = null
                this.$store.state.meetings.filters.offerResult = null
                this.$router.push({ path: '/booking/registration/all/meetings' })
            } else if (type === 'openMeetingsCount') {
                this.$store.state.meetings.filters.status = 'open'
                this.$store.state.meetings.filters.result = null
                this.$store.state.meetings.filters.offerStatus = null
                this.$store.state.meetings.filters.offerResult = null
                console.log('this.$store.state.meetings.filters', this.$store.state.meetings.filters)
                this.$router.push({ path: '/booking/registration/all/meetings' })
            } else if (type === 'offersCount') {
                this.$store.state.meetings.filters.status = 'completed'
                this.$store.state.meetings.filters.result = 'offer'
                this.$store.state.meetings.filters.offerStatus = null
                this.$store.state.meetings.filters.offerResult = null
                this.$router.push({ path: '/booking/registration/all/offers' })
            } else if (type === 'openOffersCount') {
                this.$store.state.meetings.filters.status = 'completed'
                this.$store.state.meetings.filters.result = 'offer'
                this.$store.state.meetings.filters.offerStatus = 'open'
                this.$store.state.meetings.filters.offerResult = null
                this.$router.push({ path: '/booking/registration/all/offers' })
            }
        },
        async getData (event) {
            if (event) this.calendarState = event
            const { start: { date: from }, end: { date: to } } = this.calendarState
            const { team, department, salesAgent } = this.$store.state.meetings
            this.loading = true
            this.meetings = []
            const response = await this.$http().get('/booking/registration/all/calendar', {
                params: {
                    ...this.$store.state.meetings.filters,
                    from,
                    to,
                    salesAgent,
                    team,
                    department
                }
            })
            const meetingsMap = {}
            for (let fromMoment = moment(from), toMoment = moment(to); fromMoment <= toMoment; fromMoment.add(1, 'day')) {
                meetingsMap[fromMoment.format('YYYY-MM-DD')] = {
                    meetings: 0,
                    openMeetings: 0,
                    offers: 0,
                    openOffers: 0
                }
            }
            response.data.meetings.forEach(meeting => {
                if (meetingsMap[meeting.meetingDate]) meetingsMap[meeting.meetingDate].meetings++
                if (meeting.status === 'open') meetingsMap[meeting.meetingDate].openMeetings++
                if (meeting.status === 'completed' && meeting.result === 'offer') {
                    if (meetingsMap[meeting.offerClosedDate]) {
                        meetingsMap[meeting.offerClosedDate].offers++
                        if (meeting.offerStatus === 'open') meetingsMap[meeting.offerClosedDate].openOffers++
                    }
                }
            })
            Object.keys(meetingsMap).forEach(date => {
                const dateMap = meetingsMap[date]
                if (dateMap.meetings) this.meetings.push({
                    name: dateMap.meetings + (dateMap.meetings.length > 1 ? ' møde' : ' møder'),
                    start: date,
                    timed: false,
                    type: 'meetingsCount',
                    color: 'primary darken-2'
                })
                if (dateMap.openMeetings) this.meetings.push({
                    name: dateMap.openMeetings + (dateMap.openMeetings.length > 1 ? ' åbent møde' : ' åbne møder'),
                    start: date,
                    timed: false,
                    type: 'openMeetingsCount',
                    color: 'primary'
                })
                if (dateMap.offers) this.meetings.push({
                    name: `${dateMap.offers} tilbud`,
                    start: date,
                    timed: false,
                    type: 'offersCount',
                    color: 'green darken-2'
                })
                if (dateMap.openOffers) this.meetings.push({
                    name: dateMap.openOffers + (dateMap.openOffers.length > 1 ? ' åbent tilbud' : ' åbne tilbud'),
                    start: date,
                    timed: false,
                    type: 'openOffersCount',
                    color: 'green'
                })
            })
            this.loading = false
        },
        getEventColor: ({ color }) => color
    },
    watch: {
        filters: {
            handler () {
                this.getData()
            },
            deep: true
        },
        range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
        },
        team: function () {
            this.getData()
        },
        salesAgent: function () {
            this.getData()
        },
    },
    created () {
        this.$store.state.meetings.searchString = null
    }
}
</script>